import type { Cite } from "../../contract"
import { useAnswerSession } from "../session"
import { useBlockScope } from "./context"

/** "binds" when the source's binding text says it binds the reader (Cite README). */
export function citeStatus(binds: string | null | undefined): "binds" | undefined {
  return binds && /\bbind(s|ing)?\b/i.test(binds) && !/\bnot\b|persuasive/i.test(binds) ? "binds" : undefined
}

/** Prose paragraph. Citation markers use the card-level numbers; a repeat of the same source is shown once. */
export function Para({ text, cites }: { text: string; cites: Cite[] }) {
  const { turn, sources, citeNo } = useBlockScope()
  const openSource = useAnswerSession((s) => s.openSource)
  const seen = new Set<string>()
  const marks = cites.filter((c) => (seen.has(c.source_id) ? false : (seen.add(c.source_id), true)))
  return (
    <p className="pr">
      {text}
      {marks.map((c, i) => {
        const n = citeNo[c.source_id] ?? i + 1
        const src = sources[c.source_id]
        const name = src?.name || src?.label || "source"
        const status = citeStatus(src?.binds)
        return (
          <span key={`${c.source_id}-${i}`}>
            {" "}
            <button
              type="button"
              className="cite"
              data-status={status}
              aria-label={`Open source ${n}: ${name}${status ? ", binds you" : ""}`}
              title={src?.binds || undefined}
              onClick={(e) => openSource({ turn, id: c.source_id, from: e.currentTarget })}
            >
              [{n}]
            </button>
          </span>
        )
      })}
    </p>
  )
}
